import { render, staticRenderFns } from "./c_player_teacherinfo_child.vue?vue&type=template&id=51287513&scoped=true&"
import script from "./c_player_teacherinfo_child.vue?vue&type=script&lang=js&"
export * from "./c_player_teacherinfo_child.vue?vue&type=script&lang=js&"
import style0 from "./c_player_teacherinfo_child.vue?vue&type=style&index=0&id=51287513&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51287513",
  null
  
)

export default component.exports